import { shallowEqual } from 'react-redux';

import { ParamListBase, StackActions } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack/src/types';

import { SCREEN } from 'router/screens';
import { RouteNavigationParams } from 'router/types';

import { navigationRef } from 'utils/navigation/navigationUtils';

class NavigationService {
    private currentRoute?: {
        route: SCREEN;
        params: RouteNavigationParams[SCREEN];
    };

    private navigation?: StackNavigationProp<RouteNavigationParams>;

    private getRouteNoEqual(
        route: SCREEN,
        params: RouteNavigationParams[SCREEN],
    ) {
        return (
            !this.currentRoute ||
            this.currentRoute.route !== route ||
            !shallowEqual(params, this.currentRoute.params)
        );
    }

    public setNavigation(
        navigation: StackNavigationProp<RouteNavigationParams>,
    ): void {
        this.navigation = navigation;
    }

    public navigate(
        route: SCREEN,
        params: RouteNavigationParams[SCREEN],
    ): void {
        if (this.getRouteNoEqual(route, params)) {
            this.currentRoute = { route, params };
            // @ts-ignore
            this.navigation?.navigate(route, params);
        }
    }

    public push(route: SCREEN, params: ParamListBase): void {
        if (this.getRouteNoEqual(route, params)) {
            this.currentRoute = { route, params };
            this.navigation?.push(route, params);
        }
    }
}

export const navigationService = new NavigationService();

export function reloadCurrentPage() {
    const currentScreenName = navigationRef.current?.getCurrentRoute()?.name;
    const currentScreenParams =
        navigationRef.current?.getCurrentRoute()?.params;
    if (navigationRef.isReady() && currentScreenName) {
        navigationRef.dispatch(
            StackActions.replace(currentScreenName, currentScreenParams),
        );
    }
}
